import type { ColorModeTokens, ThemePreset } from "../tokens"

/**
 * Sage Mist, imported from tweakcn
 * (https://tweakcn.com/r/themes/cmumr82kv000604l525wq97lu). Values kept in
 * oklch as the source provides them. Muted sage green primary, warm paper
 * background, generous 1rem radius, Google Sans display font (Outfit
 * originally, replaced because it has no Cyrillic).
 */
const light: ColorModeTokens = {
  background: "oklch(0.9748 0.0066 106.5213)",
  foreground: "oklch(0.3398 0.0262 223.9509)",
  card: "oklch(1 0 0)",
  cardForeground: "oklch(0.3398 0.0262 223.9509)",
  popover: "oklch(1 0 0)",
  popoverForeground: "oklch(0.3398 0.0262 223.9509)",
  primary: "oklch(0.5058 0.0566 158.831)",
  primaryForeground: "oklch(1 0 0)",
  primaryHover: "oklch(0.4582 0.0518 158.831)",
  secondary: "oklch(0.9472 0.0101 228.8915)",
  secondaryForeground: "oklch(0.4386 0.0498 239.8849)",
  muted: "oklch(0.9575 0.0073 132.4157)",
  mutedForeground: "oklch(0.5381 0.0244 174.2774)",
  accent: "oklch(0.9434 0.0133 152.5974)",
  accentForeground: "oklch(0.4205 0.0592 156.795)",
  destructive: "oklch(0.5798 0.1399 23.4928)",
  destructiveForeground: "oklch(1 0 0)",
  border: "oklch(0.9131 0.0134 152.5879)",
  input: "oklch(0.8964 0.0151 158.2179)",
  ring: "oklch(0.6485 0.0594 156.5116)",
  contrast: "oklch(0.3398 0.0262 223.9509)",
  contrastForeground: "oklch(0.9619 0.0074 197.0326)",
}

const dark: ColorModeTokens = {
  background: "oklch(0.3816 0.0324 243.587)",
  foreground: "oklch(0.9619 0.0074 197.0326)",
  card: "oklch(0.4315 0.032 238.3769)",
  cardForeground: "oklch(0.9683 0.0065 185.2734)",
  popover: "oklch(0.4558 0.0344 237.6998)",
  popoverForeground: "oklch(0.9724 0.0053 197.0692)",
  primary: "oklch(0.8449 0.0637 154.7592)",
  primaryForeground: "oklch(0.3223 0.0421 157.6646)",
  primaryHover: "oklch(0.8849 0.0637 154.7592)",
  secondary: "oklch(0.4795 0.0387 237.8108)",
  secondaryForeground: "oklch(0.9566 0.0144 224.4955)",
  muted: "oklch(0.4532 0.0316 238.2925)",
  mutedForeground: "oklch(0.8727 0.0182 223.6237)",
  accent: "oklch(0.4688 0.0412 163.4216)",
  accentForeground: "oklch(0.9547 0.0241 151.1844)",
  destructive: "oklch(0.7715 0.1041 23.3808)",
  destructiveForeground: "oklch(0.2768 0.0361 25.0831)",
  border: "oklch(0.5322 0.0303 230.8625)",
  input: "oklch(0.5712 0.0326 227.4615)",
  ring: "oklch(0.8449 0.0637 154.7592)",
  contrast: "oklch(0.4315 0.032 238.3769)",
  contrastForeground: "oklch(0.9683 0.0065 185.2734)",
}

export const sageMistPreset: ThemePreset = {
  name: "sage-mist",
  label: "Sage Mist",
  light,
  dark,
  radius: 1,
  font: "google-sans",
}
